/**
 * Load more news posts on button click using AJAX and WP REST API
 */
export default function newsLoadMore() {
    const loadMoreBtn = document.querySelector('.blog-load-more');
    if (!loadMoreBtn) return;

    // Setup
    const loadMoreBtnText = loadMoreBtn.textContent;
    const articlesContainer = document.querySelector('.news-articles');
    const template = document.getElementsByTagName('template')[0].innerHTML;
    let baseUrl = loadMoreBtn.dataset.url;
    const category = loadMoreBtn.dataset.category;
    const maxPages = loadMoreBtn.dataset.maxPages;
    let page = 2;

    // TODO: check correct functionality with Multilingual
    loadMoreBtn.addEventListener('click', function (e) {
        const apiUrl = `${baseUrl}/wp-json/pd/v1/posts?paged=${page}${
            category ? `&category=${category}` : ''
        }`;

        loadMoreBtn.setAttribute('disabled', true);
        loadMoreBtn.textContent = 'Loading...';

        fetch(apiUrl)
            .then(response => response.json())
            .then(posts => {
                if (posts.length > 0) {
                    posts.forEach(post => {
                        const { title, date, link, icon } = post;

                        // Create post markup
                        let postMarkup = template;

                        postMarkup = postMarkup.replace('NEWS_LINK', link);
                        postMarkup = postMarkup.replace(
                            'srcx="NEWS_ICON"',
                            `src="${icon}"`
                        );
                        postMarkup = postMarkup.replace('NEWS_DATE', date);
                        postMarkup = postMarkup.replace('NEWS_TITLE', title);

                        articlesContainer.innerHTML += postMarkup;
                    });
                    page++;
                }
            })
            .finally(() => {
                loadMoreBtn.removeAttribute('disabled');
                loadMoreBtn.textContent = loadMoreBtnText;

                // Remove button if no more posts
                if (page > maxPages) {
                    loadMoreBtn.remove();
                }
            });
    });
}
